import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['placeholderContainer', 'formContainer', 'textInput'];

  onPlaceholderClick(event) {
    event.preventDefault();
    this.placeholderContainerTarget.style.display = 'none';
    this.formContainerTarget.style.display = 'block';
    this.textInputTarget.focus();
  }

  onCancel() {
    this.placeholderContainerTarget.style.display = 'block';
    this.formContainerTarget.style.display = 'none';
  }
}
